module.exports = __webpack_public_path__ + "static/img/Payments.fw.e2df969.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Payments.fw.png
// module id = qm1t
// module chunks = 1